import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon, BoxIcon } from 'lucide-react';
interface MetricCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  icon?: BoxIcon;
}
export function MetricCard({
  label,
  value,
  subtitle,
  trend,
  trendValue,
  icon: Icon
}: MetricCardProps) {
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5" data-id="element-38">
      <div className="flex items-start justify-between" data-id="element-39">
        <span className="font-body text-xs font-medium uppercase tracking-wider text-white/50" data-id="element-40">
          {label}
        </span>
        {Icon && <Icon className="h-4 w-4 text-white/20" data-id="element-41" />}
      </div>
      <p className="mt-2 font-body text-2xl font-bold text-white" data-id="element-42">{value}</p>
      <div className="mt-1 flex items-center gap-2" data-id="element-43">
        {trend && trendValue && <span className={`inline-flex items-center gap-1 text-xs font-medium ${trend === 'up' ? 'text-cyan-400' : trend === 'down' ? 'text-red-400' : 'text-white/40'}`} data-id="element-44">
            {trend === 'up' && <TrendingUpIcon className="h-3 w-3" data-id="element-45" />}
            {trend === 'down' && <TrendingDownIcon className="h-3 w-3" data-id="element-46" />}
            {trend === 'neutral' && <MinusIcon className="h-3 w-3" data-id="element-47" />}
            {trendValue}
          </span>}
        {subtitle && <span className="font-body text-xs text-white/40" data-id="element-48">{subtitle}</span>}
      </div>
    </div>;
}